// extracted by mini-css-extract-plugin
export default {"type":"AddConnection_type__BCf7o"};